import {customElement, bindable} from 'aurelia-framework';

@customElement('sio-header')
export class Header
{
    @bindable() title;
    @bindable() subtitle;
}